var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backdrop",on:{"click":_vm.closeModal}},[_c('div',{staticClass:"modal"},[_c('img',{attrs:{"src":_vm.text,"width":"480","height":"480"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }